export default __webpack_public_path__ + "static/media/bg_tAndC.21f641a6.jpg";